// card-sharks — the privacy policy, as markup.
//
// MOVED HERE ON 19 SEP 2026 out of `public/privacy.html`, which was deleted — the
// nodejavascript.com site standard (parts 1b and 4) requires the policy to be a section
// of the page rather than a page of its own. The text is unchanged; only the outer
// document (its <head>, its header and its footer) was dropped, and the policy's own
// <h1> became an <h2> so the page keeps exactly one <h1>.
//
// Generated from the deleted page — edit the words here from now on.
const policyHtml = `<h2>Privacy policy</h2>
      <p class="stamp">Last changed 19 September 2026.</p>

      <p>
        This page covers one site: <b>card-sharks.nodejavascript.com</b>, a free card game
        where you guess whether the next card is higher or lower. It is written from what the
        code actually does, because a policy the site does not keep to is worse than none.
      </p>

      <h2>What the site collects</h2>
      <p>
        <b>Nothing is sent to a server.</b> The game is dealt, played and scored in your own
        browser. There is no account, no sign-in and no database holding your play.
      </p>
      <p>
        Your games, your streak and your best score are kept in your browser's own storage on
        this device so that a refresh does not lose them. They are not transmitted anywhere,
        and clearing your browser data removes them. Nothing you do in the game is ever sent
        to anyone.
      </p>

      <h2>Cookies</h2>
      <p>
        There is one optional cookie, and it is off unless you turn it on: <b>Google
        Analytics</b>, which records anonymous page views, which controls people press and how
        far down a page they read. It never receives your cards, your guesses or your history.
      </p>
      <p>
        <b>Google's script is not in this page at all.</b> It is added only if you allow it, so
        a visit that refuses makes no request to Google and receives no cookie — not "cookies
        disabled", never loaded. Your answer is remembered in your own browser's storage rather
        than in a cookie, because setting a cookie to record a cookie decision would be its own
        small joke.
      </p>
      <p>
        You can change your answer at any time with <b>Cookie settings</b> in the footer.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about this page, or about anything the site holds, can go to
        <a href="https://nodejavascript.com/">nodejavascript.com</a>.
      </p>

      <h2>Changes</h2>
      <p>
        If what the site stores changes, this page changes on the same day and the date at the
        top of it moves.
      </p>`

export default policyHtml
